import svc from "../../services/CommunicationsService";
import mapper from "../../services/ModelMapperService";

export const ADD_NEW_COMMUNICATION_POLL_OPTION = "communication/ADD_NEW_COMMUNICATION_POLL_OPTION";
export const CLEAR_RECIPIENT_TYPE_SELECTION = "communication/CLEAR_RECIPIENT_TYPE_SELECTION";
export const DESELECT_CONTACTS = "communication/DESELECT_CONTACTS";
export const DISMISS_NEW_COMMUNICATION_ERROR_ALERT = "communication/DISMISS_NEW_COMMUNICATION_ERROR_ALERT";
export const FETCHING_CONTACTS_FROM_API = "communication/FETCHING_CONTACTS_FROM_API";
export const GET_COMMUNICATION_CONTACTS_SUCCESS = "communication/GET_COMMUNICATION_CONTACTS_SUCCESS";
export const GET_COMMUNICATION_CONTACTS_FAIL = "communication/GET_COMMUNICATION_CONTACTS_FAIL";
export const GET_COMMUNICATION_RECIPIENT_LOCATORS_SUCCESS = "communication/GET_COMMUNICATION_RECIPIENT_LOCATORS_SUCCESS";
export const GET_COMMUNICATION_RECIPIENT_LOCATORS_FAIL = "communication/GET_COMMUNICATION_RECIPIENT_LOCATORS_FAIL";
export const GET_CONTACTS_BY_GROUP_DATA_SUCCESS = "communication/GET_CONTACTS_BY_GROUP_DATA_SUCCESS";
export const GET_CONTACTS_BY_GROUP_DATA_FAIL = "communication/GET_CONTACTS_BY_GROUP_DATA_FAIL";
export const HANDLE_NEW_COMMUNICATION_POLL_OPTION_CHANGE = "communication/HANDLE_NEW_COMMUNICATION_POLL_OPTION_CHANGE";
export const HANDLE_NEW_COMMUNICATION_TEXT_INPUT_CHANGE = "communication/HANDLE_NEW_COMMUNICATION_TEXT_INPUT_CHANGE";
export const POSTING_NEW_COMMUNICATION_TO_API = "communication/POSTING_NEW_COMMUNICATION_TO_API";
export const REMOVE_NEW_COMMUNICATION_POLL_OPTION = "communication/REMOVE_NEW_COMMUNICATION_POLL_OPTION";
export const RESET_NEW_COMMUNICATION_STATE = "communication/RESET_NEW_COMMUNICATION_STATE";
export const SAVE_COMMUNICATION_DRAFT_FAIL = "communication/SAVE_COMMUNICATION_DRAFT_FAIL";
export const SAVE_COMMUNICATION_DRAFT_SUCCESS = "communication/SAVE_COMMUNICATION_DRAFT_SUCCESS";
export const SEND_NEW_COMMUNICATION_FAIL = "communication/SEND_NEW_COMMUNICATION_FAIL";
export const SEND_NEW_COMMUNICATION_SUCCESS = "communication/SEND_NEW_COMMUNICATION_SUCCESS";
export const SUBMIT_NEW_COMMUNICATION_RECIPIENT_SELECTION = "communication/SUBMIT_NEW_COMMUNICATION_RECIPIENT_SELECTION";
export const SUBMIT_RECIPIENT_TYPE_SELECTION = "communication/SUBMIT_RECIPIENT_TYPE_SELECTION";
export const TOGGLE_POLL_INCLUSION = "communication/TOGGLE_POLL_INCLUSION";
export const TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL = "communication/TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL";
export const TOGGLE_REPLACE_RECIPIENTS_WARNING = "communication/TOGGLE_REPLACE_RECIPIENTS_WARNING";
export const TOGGLE_SELECTED_CONTACT = "communication/TOGGLE_SELECTED_CONTACT";
export const TOGGLE_VOICE_CALL_CHECKBOX = "communication/TOGGLE_VOICE_CALL_CHECKBOX";
export const UPDATE_RECIPIENT_TYPE_SELECTION = "communication/UPDATE_RECIPIENT_TYPE_SELECTION";
export const GET_AND_STORE_CONTACTS_FOR_LOCATIONS_SUCCESS = "GET_AND_STORE_CONTACTS_FOR_LOCATIONS_SUCCESS";
export const GET_AND_STORE_CONTACTS_FOR_LOCATIONS_FAIL = "GET_AND_STORE_CONTACTS_FOR_LOCATIONS_FAIL";
export const STORE_SELECTED_CONTACTS = "STORE_SELECTED_CONTACTS";

export function contactSelectedList(contactsInPolygon) {
    return {type: TOGGLE_SELECTED_CONTACT, contactsSelected: contactsInPolygon};
}

export function discardNewCommunication() {
    return {type: RESET_NEW_COMMUNICATION_STATE};
}

export function dismissNewCommunicationErrorAlert() {
    return {type: DISMISS_NEW_COMMUNICATION_ERROR_ALERT};
}

export function getCommunicationRecipientLocators(){
    return(dispatch) => {
        dispatch(setFetching());

        return svc.communicationRecipientLocators
            .then(result => {
                dispatch({type: GET_COMMUNICATION_RECIPIENT_LOCATORS_SUCCESS, contacts:result});
            })
            .catch(err => dispatch({type: GET_COMMUNICATION_RECIPIENT_LOCATORS_FAIL, err}));
    };
}

export function getCommunicationContacts() {
    return (dispatch) => {
        dispatch(setFetching());

        return svc.communicationContacts
            .then(result => {
                const sortedContacts = mapper.mapCommunicationContacts(result);
                dispatch({type: GET_COMMUNICATION_CONTACTS_SUCCESS, contacts: sortedContacts});
            })
            .catch(err => dispatch({type: GET_COMMUNICATION_CONTACTS_FAIL, err}));
    };
}

export function getContactsByGroupData() {
    return (dispatch) => {
        dispatch(setFetching());

        return svc.contactsByGroupData
            .then(result => {
                const mappedContactData = mapper.mapContactsByGroupData(result);
                dispatch({type: GET_CONTACTS_BY_GROUP_DATA_SUCCESS, contactData: mappedContactData});
            })
            .catch(err => dispatch({type: GET_CONTACTS_BY_GROUP_DATA_FAIL, err}));
    };
}

export function handleNewCommunicationPollOptionChange(index, value) {
    return {type: HANDLE_NEW_COMMUNICATION_POLL_OPTION_CHANGE, index: index, value: value};
}

export function handleNewCommunicationTextInputChange(name, value) {
    return {type: HANDLE_NEW_COMMUNICATION_TEXT_INPUT_CHANGE, name: name, value: value};
}

export function removeNewCommunicationPollOption(index) {
    return {type: REMOVE_NEW_COMMUNICATION_POLL_OPTION, index: index};
}

export function saveCommunicationDraft(communicationDetails) {
    return (dispatch) => {
        dispatch(setPosting());
        return svc.saveCommunicationDraft(communicationDetails)
            .then((result) => {
                dispatch({type: SAVE_COMMUNICATION_DRAFT_SUCCESS, saveResult: result});
            })
            .catch(err => dispatch({type: SAVE_COMMUNICATION_DRAFT_FAIL, err}));
    };
}

export function selectRecipientsForEvent() {
    return dispatch => {
        dispatch({type: TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL});
        dispatch({type: UPDATE_RECIPIENT_TYPE_SELECTION, selectBy: 'group'});
        dispatch({type: SUBMIT_RECIPIENT_TYPE_SELECTION});
    };
}

export function sendNewCommunication(newCommunicationDetails) {
    return (dispatch) => {
        dispatch(setPosting());
        return svc.sendNewCommunication(newCommunicationDetails)
            .then((result) => {
                dispatch(sendNewCommunicationSuccess(result));
            })
            .catch((err) => dispatch(sendNewCommunicationFail(err)));
    };
}

export function sendNewCommunicationFail(err) {
    return {type: SEND_NEW_COMMUNICATION_FAIL, error: err};
}

export function sendNewCommunicationSuccess(result) {
    return {type: SEND_NEW_COMMUNICATION_SUCCESS, sendResult: result};
}

export function setFetching() {
    return {type: FETCHING_CONTACTS_FROM_API};
}

export function setPosting() {
    return {type: POSTING_NEW_COMMUNICATION_TO_API};
}

export function submitNewCommunicationRecipientSelection(recipientsList) {
    return {type: SUBMIT_NEW_COMMUNICATION_RECIPIENT_SELECTION, recipients: recipientsList};
}

export function getAndStoreContactsForRecipientLocations(recipientLocations) {
    return (dispatch) => {
        return svc.getContactsForLocations(recipientLocations)
            .then((result) => {
                dispatch(getAndStoreContactsForLocationsSuccess(result));
            })
            .catch((err) => dispatch(getAndStoreContactsForLocationsFail(err)));
    };
}
export function getAndStoreContactsForLocationsFail(err) {
    return {type: GET_AND_STORE_CONTACTS_FOR_LOCATIONS_FAIL, error: err};
}

export function getAndStoreContactsForLocationsSuccess(result) {
    return {type: GET_AND_STORE_CONTACTS_FOR_LOCATIONS_SUCCESS, contacts: result};
}

export function storeSelectedContacts(contacts) {
    return dispatch => dispatch({type: STORE_SELECTED_CONTACTS, contacts: contacts});
}